import { useState } from 'react';
import { useLatest } from 'react-use';

import { useFunction } from './useFunction';

interface Params {
    initialState?: boolean;
    onOpened?: () => void;
    onClosed?: () => void;
}

export interface OpenClosedState {
    isOpen: boolean;
    open: () => void;
    close: () => void;
    toggle: (shouldOpen?: boolean) => void;
}

export function useOpenClosedState({
    initialState = false,
    onOpened,
    onClosed,
}: Params = {}): OpenClosedState {
    const [isOpen, setOpen] = useState(initialState);
    const callbacks = useLatest({ onOpened, onClosed });

    const open = useFunction(() => {
        if (!isOpen) {
            setOpen(true);
            callbacks.current.onOpened?.();
        }
    });

    const close = useFunction(() => {
        if (isOpen) {
            setOpen(false);
            callbacks.current.onClosed?.();
        }
    });

    const toggle = useFunction((shouldOpen?: boolean) => {
        if (shouldOpen === true) {
            return open();
        }
        if (shouldOpen === false) {
            return close();
        }
        if (isOpen) {
            return close();
        }
        return open();
    });

    return {
        isOpen,
        open,
        close,
        toggle,
    };
}
